<ng-container *ngFor="let option of options">
  <app-ds-checkbox [label]="option.option_text" [checked]="isChecked(option.id)" (clicked)="onToggleOption(option.id)"></app-ds-checkbox>
</ng-container>
